<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Cargos</h5>
                <hr>

				<Toolbar class="p-mb-4">
					<template slot="left">						
						<Button type="button" icon="pi pi-plus" label="Novo" class="p-mr-2" @click="novo" v-if="permissaoNovo"/>						
					</template>
				</Toolbar>

				<DataTable :value="cargos" :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,20,30,50]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">			
							<div class="p-d-flex p-jc-end">				
								<span class="p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filtro['global']" placeholder="Filtrar..." />
								</span>
							</div>
						</div>
					</template>
					<Column field="codigo" header="Código" sortable></Column>
					<Column field="nome" header="Nome" sortable></Column>				
					<Column>
						<template #body="slotProps">
							<Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2" @click="editar(slotProps.data)" v-if="permissaoEditar"/>
							<Button icon="pi pi-trash" title="Excluir" class="p-button-rounded p-button-danger" @click="confirmarExcluir(slotProps.data)" v-if="permissaoExcluir"/>
						</template>
					</Column>
				</DataTable>

				<Dialog :visible.sync="exibirDialogCadastro" :header="tituloModal" :modal="true" class="p-fluid" :style="{width: '500px'}">			
					<div class="p-fluid p-formgrid p-grid">
						<div class="p-field p-col-12 p-md-6">
							<label for="codigo">Código</label>
							<InputText id="codigo" v-model.trim="cargoSelecionado.codigo" required="true" autocomplete="off" :disabled="cargoSelecionado.gerarCodogioEmSequencia"/>
							<small class="p-invalid" v-if="enviandoForm && !cargoSelecionado.gerarCodogioEmSequencia && !cargoSelecionado.codigo">Informe o código</small>
						</div>	
						<div class="p-field p-col-6 p-md-6" v-if="cargoSelecionado.id == null">
							<label style="color: #ffffff">.</label>
							<div class="p-field-checkbox">
								<Checkbox v-model="cargoSelecionado.gerarCodogioEmSequencia" :binary="true"/>
								<label>Geração Automática</label>
							</div>
						</div>				
					</div>	
					<div class="p-fluid p-formgrid p-grid">					
						<div class="p-field p-col">
							<label for="nome">Nome</label>
							<InputText id="nome" v-model.trim="cargoSelecionado.nome" required="true" autocomplete="off"/>
							<small class="p-invalid" v-if="enviandoForm && !cargoSelecionado.nome">Informe o nome</small>
						</div>
					</div>				
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
						<Button label="Salvar" icon="pi pi-check" @click="salvar"/>
					</template>
				</Dialog>

				<Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}">
					<div class="confirmation-content">
						<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
						<span>Excluir cargo <b>{{ cargoSelecionado.nome }}</b>?</span>
					</div>
					<template #footer>
						<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="limparExcluir"/>
						<Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
					</template>
				</Dialog>

			</div>
		</div>
	</div>
</template>

<script>
import CargoService from '@/service/CargoService';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
	cargoService: null,
	data() {
		return {
			permissaoNovo: false,
			permissaoEditar: false,
			permissaoExcluir: false,
			tituloModal: 'Novo Cargo',
			exibirDialogConfirmarExcluir: false,
			exibirDialogCadastro: false,		
			enviandoForm: false,
			cargoSelecionado: {codigo:'', nome:'', gerarCodogioEmSequencia: true},
			cargos: [],		
			filtro: {}
		}
	},
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao','getPermissoes']),		
		listar() {					
			this.cargoService.listar({...this.getDadosRequisicao()})
				.then(resp => {
					this.cargos = resp.data;
                })
                .catch(erro => {exibirMensagem(this, erro)});   
		},
		novo() {		
			this.tituloModal = 'Novo Cargo';	
			this.cargoSelecionado = {codigo:'', nome:'', gerarCodogioEmSequencia: true};
			this.exibirDialogCadastro = true;
			this.enviandoForm = false;
		},
		salvar() {
			this.enviandoForm = true;
			if(this.cargoSelecionado.id) {				
				this.cargoSelecionado.gerarCodogioEmSequencia = false;
				if(this.cargoSelecionado.nome == '' || this.cargoSelecionado.codigo == '') {					
					return;
				}
			} else {				
				if(this.cargoSelecionado.gerarCodogioEmSequencia && this.cargoSelecionado.nome == '') {					
					return;
				}
				if(!this.cargoSelecionado.gerarCodogioEmSequencia && (this.cargoSelecionado.nome == '' || this.cargoSelecionado.codigo == '')) {					
					return;
				}
			}			
			let requisicao = {
				cargo: {...this.cargoSelecionado},
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}			
			this.cargoService.salvar(requisicao)
			.then(resp => {	
				this.fecharModal();
				this.listar();
				exibirMensagem(this, resp);						
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		excluir() {
			let requisicao = {
				cargo: {...this.cargoSelecionado},
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}			
			this.cargoService.excluir(requisicao)
				.then(resp => {	
					this.limparExcluir();
					this.listar();
					exibirMensagem(this, resp);						
				})
				.catch(erro => {exibirMensagem(this, erro)});
		},
		editar(cargo) {
			this.enviandoForm = false;
			let requisicao = {
				idCargo: cargo.id,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}	
			this.cargoService.buscar(requisicao)
				.then(resp => {	
					this.tituloModal = 'Editar Cargo';
					this.cargoSelecionado = resp.data;
					this.exibirDialogCadastro = true;				
				})
				.catch(erro => {exibirMensagem(this, erro)});
		},
		confirmarExcluir(cargo) {
			this.cargoSelecionado = cargo;
			this.exibirDialogConfirmarExcluir = true;
		},
		limparExcluir() {
			this.cargoSelecionado = {codigo:'', nome:'', gerarCodogioEmSequencia: true};
			this.exibirDialogConfirmarExcluir = false;
		},
		fecharModal() {
			this.cargoSelecionado = {codigo:'', nome:'', gerarCodogioEmSequencia: true};
			this.exibirDialogCadastro = false;
			this.enviandoForm = false;
		},
		validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(20);
			this.permissaoEditar = permissoes.includes(21);
			this.permissaoExcluir = permissoes.includes(22);			
		}
	},
	created() {
		this.cargoService = new CargoService();		
	},
	mounted() {	
		this.validarPermissoes();	
		this.listar();
	}
}
</script>

<style scoped>
</style>